<app-orders-panel [limit]="3" [title]="'Ostatnie zamówienia'"></app-orders-panel>
